<template>
  <div class="login">
    <div class="login__top">
     
      <span
        class="login__close"
        @click="closeModal"
        v-on:keyup.enter="closeModal"
        tabindex="0"
        aria-label="Anuluj"
       />
    </div>
    <div class="login__flex">
      <div class="login__left">
        <div class="photo__border">
          <div class="photo__content"></div>
        </div>
        <ul class="login__menu">
          <li v-on:click="content='profile'" :class="content=='profile'? 'menu__item active':'menu__item'">
            <img class="menu__icon" src="@/assets/profil.svg">
            <span class="menu__title">Twój profil</span>
          </li>
           <li v-on:click="content='notes'" :class="content=='notes'? 'menu__item active':'menu__item'">
            <img class="menu__icon" src="@/assets/notowanie.svg">
            <span class="menu__title" v-on:click="refresh">Twoje notowania</span>
          </li>
           <li v-on:click="content='passChange'" :class="content=='passChange'? 'menu__item active':'menu__item'">
            <img class="menu__icon" src="@/assets/haslo.svg">
            <span class="menu__title">Zmień hasło</span>
          </li>
        </ul>
        <button v-on:click="logOut" class="login__button">wyloguj</button>


      </div>
      <div class="login__right">
        <div v-if="content=='profile'">
          <span class="login__username">{{username}}</span>
          <span class="login__email"><div class="login__envelope"></div>{{email}}</span>
          <span class="login__title">twój profil</span>

          <span class="login__subtitle">dane osobowe</span>
          <div class="login__section">
            <div class="input__row">
              <div class="input">
                <label for="name" class="input__label">imię</label>
                <input type="text" id="name" name="name" class="input__input"/>
              </div>
               <div class="input">
                <label for="surname" class="input__label">nazwisko</label>
                <input type="text" id="name" name="name" class="input__input"/>
              </div>
            </div>
          </div>
          <span class="login__subtitle">zmień adres e-mail</span>

          <div class="login__section">
             <div class="input__row input__row--single">
              <div class="input">
                <label for="currentEmail" class="input__label" >aktualny adres e-mail</label>
                <input type="text" id="currentEmail" name="currentEmail" v-model="currentEmail" class="input__input"/>
              </div>
              
            </div>
             <div class="input__row" :class="{'invalid__form': invalid}">
              <div class="input">
                <label for="newEmail" class="input__label">nowy adres e-mail</label>
                <input type="text" id="newEmail" name="newEmail" v-model="newEmail" class="input__input"/>
              </div>
               <div class="input">
                <label for="confirmEmail" class="input__label">potwierdź adres e-mail</label>
                <input type="text" id="confirmEmail" name="confirmEmail" v-model="repeatEmail" class="input__input"/>
              </div>
            </div>
            <span class="inputs__warning">{{showErrorInfo}}</span>
          </div>


          <div class="login__confirm">
            <button class="login__button login__button--gradient" v-on:click="confirmChanges">Zachowaj zmiany </button>
          </div>
</div>


                <div v-if="content=='notes'">
                 <YourNotes :username='username' :email="email" :refreshNotes="refreshNotes"></YourNotes>
                </div>



        <div v-if="content=='passChange'">
          
              <span class="login__username">{{username}}</span>
          <span class="login__email"><div class="login__envelope"></div>{{email}}</span>
          <span class="login__title">zmień hasło</span>
          <span class="login__subtitle">bądź bezpieczny</span>
          <div class="login__section">
            <div class="input__row input__row--single">
              <div class="input">
                <label for="currentPassword" class="input__label">aktualne hasło</label>
                <input type="password" id="currentPassword" v-model="oldPassword" name="oldPassword" class="input__input"/>
              </div>
             </div>
                         <div class="input__row input__row--single">
                           <span class="password__reminder">
                             Wprowadź hasło składające się z 8-32 znaków. Dla zwiększenia bezpieczeństwa Twojego konta, hasło musi zawierać przynajmniej 1 cyfrę i przynajmniej jedną dużą literę.
                           </span>
                         </div>
                           <div class="input__row input__row--single" :class="{'invalid__form': invalid}">
              <div class="input">
                <label for="newPassword" class="input__label">nowe hasło</label>
                <input type="text" id="newPassword" name="newPassword" v-model="newPassword" class="input__input"/>
              </div>
             </div>
               <div class="input__row input__row--single" :class="{'invalid__form': invalid}">
              <div class="input">
                <label for="repeatNewPassword" class="input__label">potwierdź nowe hasło</label>
                <input type="text" id="repeatNewPassword" name="repeatNewPassword" v-model="repeatPassword" class="input__input"/>
              </div>
             </div>


            <span class="inputs__warning">{{showErrorInfo}}</span>

          </div>
          <div class="login__confirm">

      <button class="login__button login__button--gradient" v-on:click="changePassword">Zachowaj zmiany </button>
          </div>
        </div>


      </div>
    </div>
    
  </div>
</template>

<script>
import mixin from '../mixin';
import YourNotes from '../../YourNotes/Desktop/YourNotes';

export default {
  mixins: [mixin],
  components: {
    YourNotes
  }
};
</script>

<style scoped lang="scss">
.input__row.invalid__form input {
    border: 1px solid red;
}
.inputs__warning {
  margin-top: 1rem;
    display: block;
    text-align: right;
    color: red;
    font-size: 0.8rem;
}
.logout__icon {
  width: 12px;
  height: 12px;
  background-position: center;
  background-size: cover;
  background-image: url(../../../assets/logout__arrow.png)
}
.password__reminder {
    font-size: 0.7rem;
    line-height: 1.5;
}
.login__envelope {
  background-image: url(../../../assets/editprofile__envelope.png);
  width: 12px;
  height: 8px;
  background-size: cover;
  background-position: center;
  margin-right: 1em;
}
.photo {
  &__border {
        margin: auto;

    background-color: #636979;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 5rem;
    height: 5rem;
    border-radius: 50%;
    margin-top: 2rem;
  }
  &__content {
    width: 4rem;
    height: 4rem;
    background-color: #df2860;
    border-radius: 50%;
    border: 3px solid white;
  }
}
.input {
  width: 46%;
  &__row {
        display: flex;
    justify-content: space-between;
    align-items: center;
        padding-top: 1.5rem;
        &--single {
          justify-content: flex-start;
        }


  }
  &__label {
    text-transform: uppercase;
    font-size: 0.6rem;
    margin-bottom: 0.2rem;
    display: block;
    color: #9b9b9b;



  }
  &__input {
    width: 100%;
    height: 2rem;
    border: none;
    border-radius: 5px;
    background-color: #efedee;
        padding-left: 7%;
    font-size: 0.7rem;
    font-family: "Poppins", sans-serif;
    color: #2c253f;
    box-sizing: border-box;
  }
}
.login {
  width: 94%;
    max-width: 1200px;
  background-color: #ffffff;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  align-items: center;
  &__buttons {
    width: 28%;
  }
  &__section {
    width: 94%;
    margin-left: 3%;
    border-top: 1px solid #cfd1e0;
    margin-top: -1px;
  }
  &__subtitle {
    display: block;
    margin-left: 3%;
    margin-top: 1.5rem;
    text-transform: uppercase;
    font-weight: 600;
    font-size: 0.9rem;
    border-bottom: 4px solid #df2860;
    width: fit-content;
    padding-bottom: 0.3rem;
  }
  &__menu {
        margin: auto;

    margin-top: 5rem;
    width: 80%;



  }
  .photo__content {
    background-image: url(../../../assets/profil--white.svg);
  }
  .menu {
    &__item {
      margin: 2rem 0;
          display: flex;
    align-items: center;
    cursor: pointer;
    opacity: 0.5;
    &.active {
      opacity: 1;
    }
    }
    &__icon {
      margin-right: 0.3rem;
    height: 1.2rem;
    }
    &__title {
      font-size: 0.8rem;
      color: #5142c0;
    }
  }
  &__username{
    display: block;
    margin-left: 3%;
    font-size: 1.5rem;
    margin-top: 2rem;
}


  &__email{
    display: flex;
    margin-left: 3%;
    align-items: center;
    font-size: 0.7rem;
    margin-top: 0.7rem;
    height: 1.1rem;
}
  &__invalid {
    color: red;
    text-align: center;
    line-height: 1.5;
  }
  &__top {
    height: 3rem;
    width: 100%;
    background-image: linear-gradient(to right, #df2860, #af2f82);
    position: relative;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
  display: flex;
    align-items: center;

  }
  &__flex {
    display: flex;
    width: 100%;
    height: 100%;
  }
  &__button {
    position: absolute;
    bottom: 1.5em;
    left: 10%;
    width: 80%;
    height: 2rem;
    text-transform: uppercase;
    font-size: 0.7rem;
    border: none;
    background-color: #df2860;
    color: #fafafa;
    border-radius: 5px;
    display: flex;
        justify-content: center;
    align-items: center;
    height: 2rem;
    font-family: 'Poppins', sans-serif;
    text-transform: uppercase;
    cursor: pointer;
    &--gradient {
        background-color: #af2f82;
    background-image: linear-gradient(to right, #df2860, #af2f82);
        width: fit-content;
    padding: 0 15px;
    right: 3%;
    left: auto;


    }
  }
  &__left {
       min-height: 65vh;

    width: 23%;
    background-color: #e6e6ee;
    position:relative;
  }
  &__right {
    width: 77%;
    position: relative;
  }
  &__title {
    font-family: 'Poppins';
    color: white;
    font-family: 'Poppins';
    color: white;
    display: flex;
    height: 2rem;
    background-color: #df2860;
    width: 30%;
    text-transform: uppercase;
    align-items: center;
    margin-top: 4rem;
    padding-left: 3%;
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;

  }
  &__form {
    width: 66%;
    display: flex;
    flex-direction: column;
    margin-top: 2.5rem;
  }
  &__close {
    color: #fff;
    font-size: 30px;
    position: absolute;
    top: 1rem;
    right: 1rem;
    cursor: pointer;

    width: 1.25rem;
    height: 1.25rem;
    display: block;
    background-image: url("~@/assets/loginModal__close.png");
    background-size: cover;
    background-position: center;
  }

  
  .flex {
    &__checkbox {
      margin: 0;

      &:hover {
        cursor: pointer;
      }
    }
    &__remember {
      display: flex;
      align-items: center;
      font-size: 11px;
    }
    &__forgot {
      font-size: 11px;
      &:hover {
        text-decoration: underline;
        cursor: pointer;
      }
    }
    &__label {
      margin-left: 0.5rem;
      &:hover {
        cursor: pointer;
      }
    }
  }


  &__cancel {
    width: 100%;
    height: 2.5rem;
    font-size: 1rem;
    text-transform: uppercase;
    border: none;
    border-radius: 5px;
    color: #0f1626;
    letter-spacing: 0.8px;
    margin-bottom: 1rem;

    background-color: transparent;
    cursor: pointer;
    &:hover {
      background-color: darken(#fff, 10%);
    }
  }
}
</style>
